export enum InputMask
{
    none = "",
    date = "dd.mm.yyyy",
    time = "hh:mm",
    number = "numeric"
}